/* ******************************************** *
 * ** ORDERSTATUSES TRANSLATION GROUP KEYS FOR HUMAN READABLE ORDER AND ITEM STATUSES ** *
 * ******************************************** */

export const OrderStatus = {
  IN_PROGRESS: 'inProgress',
  SHIPPED: 'shipped',
  CANCELLED: 'cancelled',
  CANCEL_REQUESTED: 'cancelRequested',
  FAILED: 'failed',
  COMPLETED: 'completed',
} as const;
